<template lang="">
    <el-form :model="po.configForm" ref="poFormRef" label-width="140px">
        <el-form-item prop="e_title" label="头部轮播图">
            <template #label>
                <div>
                    <div>头部轮播图</div>
                    <div class="sub-label">建议尺寸: 1920*442px</div>
                </div>
            </template>
            <div class="flex multi-imgs" style="width: 100%">
                <fileUploader @uploadBack="(e, f) => uploadBackDetail(e, f)" />
                <div class="limit-area">
                    <div v-for="(item, index) in po.configForm.headerImgs" :key="index" class="flex flex-start mgb">
                        <div style="position: relative; margin-right: 8px">
                            <el-image
                                style="width: 100px; height: 100px; border: 1px solid #dddddd"
                                :src="requestDomain + item.url"
                                fit="contain"
                            />
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-delete" @click="uploadBackDetail('', true, index)">
                                    <el-icon><Delete /></el-icon>
                                </span>
                            </span>
                        </div>
                        <el-input v-model="item.jump_url"></el-input>
                    </div>
                </div>
            </div>
        </el-form-item>
        <el-form-item prop="e_title" label="头部广告图">
            <template #label>
                <div>
                    <div>头部广告图</div>
                    <div class="sub-label">建议尺寸: 426*129px</div>
                </div>
            </template>
            <div class="flex multi-imgs" style="width: 100%">
                <fileUploader @uploadBack="(e, f) => uploadBackAdDetail(e, f)" />
                <div class="limit-area">
                    <div v-for="(item, index) in po.configForm.headerAdImgs" :key="index" class="flex flex-start mgb">
                        <div style="position: relative; margin-right: 8px">
                            <el-image
                                style="width: 100px; height: 100px; border: 1px solid #dddddd"
                                :src="requestDomain + item.url"
                                fit="contain"
                            />
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-delete" @click="uploadBackAdDetail('', true, index)">
                                    <el-icon><Delete /></el-icon>
                                </span>
                            </span>
                        </div>
                        <el-input v-model="item.jump_url"></el-input>
                    </div>
                </div>
            </div>
        </el-form-item>
        <el-form-item prop="e_title" label="底部广告图">
            <template #label>
                <div>
                    <div>底部广告图</div>
                    <div class="sub-label">建议尺寸: 426*129px</div>
                </div>
            </template>
            <div class="flex multi-imgs" style="width: 100%">
                <fileUploader @uploadBack="(e, f) => uploadBackFooter(e, f)" />
                <div class="limit-area">
                    <div v-for="(item, index) in po.configForm.footerImgs" :key="index" class="flex flex-start">
                        <div style="position: relative; margin-right: 8px">
                            <el-image
                                style="width: 100px; height: 100px; border: 1px solid #dddddd"
                                :src="requestDomain + item.url"
                                fit="contain"
                            />
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-delete" @click="uploadBackFooter('', true, index)">
                                    <el-icon><Delete /></el-icon>
                                </span>
                            </span>
                        </div>
                        <el-input v-model="item.jump_url"></el-input>
                    </div>
                </div>
            </div>
        </el-form-item>
        <el-form-item prop="e_title" label="二维码设置">
            <div class="flex multi-imgs" style="width: 100%">
                <fileUploader @uploadBack="(e, f) => uploadBackPr(e, f)" />
                <div class="limit-area">
                    <div v-for="(item, index) in po.configForm.prImgs" :key="index" class="flex flex-start">
                        <div style="position: relative; margin-right: 8px">
                            <el-image
                                style="width: 100px; height: 100px; border: 1px solid #dddddd"
                                :src="requestDomain + item.url"
                                fit="contain"
                            />
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-delete" @click="uploadBackPr('', true, index)">
                                    <el-icon><Delete /></el-icon>
                                </span>
                            </span>
                        </div>
                        <el-input v-model="item.jump_url"></el-input>
                    </div>
                </div>
            </div>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item>
            <el-button type="primary" @click="submitForm">确 认</el-button>
        </el-form-item>
    </el-form>
</template>
<script setup>
import request from '@/request/index.js';
import { reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { Plus, Delete } from '@element-plus/icons-vue';
import fileUploader from '@/components/fileUploader.vue';
import { requestDomain } from '../../../package.json';
const po = reactive({
    configForm: {
        saleNetNote: '',
        shouceNote: '',
        memberPrice: '',
        headerImgs: [],
        headerAdImgs: [],
        footerImgs: [],
        chooseImgs: [],
        prImgs: [],
        kefuPhone: '',
        kefuImg: null,
        remindDate: ''
    }
});
const uploadBackDetail = (e, isRemove, index) => {
    if (isRemove) {
        po.configForm.headerImgs.splice(index, 1);
    } else {
        e.jump_url = '';
        po.configForm.headerImgs.push(e);
    }
};
const uploadBackAdDetail = (e, isRemove, index) => {
    if (isRemove) {
        po.configForm.headerAdImgs.splice(index, 1);
    } else {
        e.jump_url = '';
        po.configForm.headerAdImgs.push(e);
    }
};
const uploadBackHeaderSub = (e, isRemove, index) => {
    if (isRemove) {
        po.configForm.headerImgs[index].detail = null;
    } else {
        po.configForm.headerImgs[index].detail = e;
    }
};
const uploadBackFooterSub = (e, isRemove, index) => {
    if (isRemove) {
        po.configForm.footerImgs[index].detail = null;
    } else {
        po.configForm.footerImgs[index].detail = e;
    }
};
const uploadBackFooter = (e, isRemove, index) => {
    if (isRemove) {
        po.configForm.footerImgs.splice(index, 1);
    } else {
        e.jump_url = '';
        po.configForm.footerImgs.push(e);
    }
};
const uploadBackChoose = (e, isRemove, index) => {
    if (!po.configForm.chooseImgs) {
        po.configForm.chooseImgs = [];
    }
    if (isRemove) {
        po.configForm.chooseImgs.splice(index, 1);
    } else {
        e.jump_url = '';
        po.configForm.chooseImgs.push(e);
    }
};
const uploadBackChooseSub = (e, isRemove, index) => {
    if (isRemove) {
        po.configForm.chooseImgs[index].detail = null;
    } else {
        po.configForm.chooseImgs[index].detail = e;
    }
};
const uploadBackPr = (e, isRemove, index) => {
    if (isRemove) {
        po.configForm.prImgs.splice(index, 1);
    } else {
        e.jump_url = '';
        po.configForm.prImgs.push(e);
    }
};
const uploadRef = ref();
const handleSuccess = e => {
    po.configForm.kefuImg = e;
    uploadRef.value.clearFiles();
};
const uploadRefFooter = ref();
const handleSuccessFooter = e => {
    po.configForm.footerLogo = e.url;
    uploadRefFooter.value.clearFiles();
};
const fetchGlobalConfig = async () => {
    const rsp = await request('fetchGlobalConfig', { type: 'pc' });
    if (rsp.status === 200 && rsp.data.length > 0) {
        po.configForm = JSON.parse(rsp.data[0].config_content);
    }
};

const submitForm = async () => {
    const rsp = await request('updateGlobalConfig', { config_content: JSON.stringify(po.configForm), type: 'pc' });
    if (rsp.status === 200) {
        ElMessage({ message: rsp.msg, type: 'success' });
    }
};
fetchGlobalConfig();
</script>
<style lang="scss">
.limit-input {
    width: 480px;
}
.attachment-uploader .el-button {
    height: 100px;
    width: 100px;
    border: 1px dashed #cdd0d6;
}
.multi-imgs .el-upload-list__item {
    display: none;
}
.limit-area {
    width: 640px !important;
}
.sub-label {
    font-size: 10px;
    color: #666;
}
</style>
